<template>
  <el-container height="auto" style="overflow:hidden;">
    <el-header style="margin:0px;padding:0px;padding-bottom:5px;height:35px;">
          <el-row type="flex" justify="end">
            <el-col :span="12">
              <el-link  style="font-size:16px;color:#409EFF;" :underline="false" @click="reloadList">
                我发起的研究
                <i class="el-icon-refresh el-icon--right" style="font-size:20px;"></i>
              </el-link>
              <el-divider direction="vertical"></el-divider>
              <el-link  @click="$router.push({path:'/home/projectform'})" style="font-size:16px;" :underline="false" >表单</el-link>
            </el-col>
            <el-col :span="12" style="text-align:right;padding-right:15px;">

              <el-button type="primary" size="mini" @click="createProject()">新建研究</el-button>
              &nbsp;
              <el-popover
                placement="bottom"
                title=""
                width="400"
                trigger="click"
                style="cursor:pointer;"
                @show="showfilter"
                >
                <el-input
                    ref="searchinput"
                    placeholder="输入研究名称进行搜索"
                    prefix-icon="el-icon-search"
                    v-model="search"
                    clearable
                    >
                  </el-input>

               <el-link slot="reference" :underline="false">
                  {{(this.search != '') ?'已筛选':'筛选'}}
                  <i class="fa fa-filter" style="font-size:20px;"></i>
                </el-link>
              </el-popover>
            </el-col>
          </el-row>
        </el-header>
    <el-main style="margin:0px;padding:0px;">
      <el-table 
          v-loading="loading" 
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background=""
          :empty-text="emptytext"
          :data="filterProjectList.slice((currentPage1-1)*pageSize1,currentPage1*pageSize1)" :show-header="false">
        <el-table-column label="名称"  prop="scope.row.name">
       
          <template slot-scope="scope">
            <div style="vertical-align:middle;line-height:25px;">

              <el-row type="flex" align="middle">
                <el-col :span="1"><i class="fa fa-medkit fa-2x" ></i></el-col>
                <el-col :span="21" style="font-size:20px;">
                  <el-link type="primary" @click="openSDC(scope.row.projectid)" style="font-size:16px;">{{scope.row.name}}</el-link>
                </el-col>
                <el-col :span="2" style="text-align:right;">
                <i v-if="scope.row.starflag||'' != '' "  class="fa fa-star starflag_5" style="font-size:20px;cursor:pointer;" @click="flagStar(scope.row.projectid,'0')"></i>
                  <i v-else class='fa fa-star-o starflag' style="font-size:20px;cursor:pointer;" @click="flagStar(scope.row.projectid,'5')"></i>
                  <el-popover>
                    <el-button icon="el-icon-edit"  type="mini"  style="font-size:13px;border:0px solid black;" @click="editProject(scope.row.projectid)">编辑研究</el-button>
                    <br>
                    <el-button icon="el-icon-delete"  type="mini"  style="font-size:13px;border:0px solid black;" @click="delProject(scope.row.projectid)">删除研究</el-button>
                    <el-button slot="reference"  type="mini" style="font-size:18px;border:0px solid black">...</el-button>
                  </el-popover>
                </el-col>
              </el-row>
            </div>
            <!-- 现状情况 -->
            <el-row type="flex" align="middle">
              <el-col :span="12">
                <i class="fa fa-hospital-o" ></i> 研究单位数：<span style="font-size:20px;">{{computedProject(scope.row.projectid).storecount}}</span>&nbsp; 
                <i class="fa fa-user-md" ></i> 团队成员数量：<span style="font-size:20px;">{{computedProject(scope.row.projectid).usercount}}</span>&nbsp;   
                <i class="fa fa-user" ></i> 入组数量：<span style="font-size:20px;">{{computedProject(scope.row.projectid).subjectcount}}</span>&nbsp;  
              </el-col>
              <el-col :span="12" style="text-align:right;">
              </el-col>
            </el-row>

            <el-table :data="(computedProject(scope.row.projectid).stores || []).slice((currentPage-1)*pageSize,currentPage*pageSize)">
              <el-table-column label="编号"  prop="sitenumber">
              </el-table-column>
              <el-table-column label="研究单位" prop="storename">
              </el-table-column>
              <el-table-column label="研究者" prop="pis">
              </el-table-column>
              <el-table-column label="受试者数"  prop="name">
                  <template slot="header" slot-scope="slotheader">
                    受试者数({{computedProject(scope.row.projectid).n1}})
                  </template>
                  <template slot-scope="scope1">
                    <el-row type="flex" align="middle">
                      <el-col :span="4" style="text-align:right;line-height:25px; padding-right:5px;font-size:16px;">{{scope1.row.m1}}</el-col>
                      <el-col :span="20">
                        <el-progress :text-inside="true" :stroke-width="15" :percentage="parseFloat(scope1.row.p1)" :show-text="false"></el-progress>
                      </el-col>
                    </el-row>
                  </template>
              </el-table-column>
              <el-table-column label="记录数"  prop="name">
                <template slot="header" slot-scope="slotheader">
                  记录数({{computedProject(scope.row.projectid).n2}})
                </template>
                <template slot-scope="scope1">
                    <el-row type="flex" align="middle">
                      <el-col :span="4" style="text-align:right;line-height:25px; padding-right:5px;font-size:16px;">{{scope1.row.m2}}</el-col>
                      <el-col :span="20">
                        <el-progress :text-inside="true" :stroke-width="15" :percentage="parseFloat(scope1.row.p2)" :show-text="false" status="success"></el-progress>
                      </el-col>
                    </el-row>
                  </template>


              </el-table-column>
              <el-table-column label="质疑数"  prop="name">
                <template slot="header" slot-scope="slotheader">
                  质疑数({{computedProject(scope.row.projectid).n3}})
                </template>
                <template slot-scope="scope1">
                    <el-row type="flex" align="middle">
                      <el-col :span="4" style="text-align:right;line-height:25px; padding-right:5px;font-size:16px;">{{scope1.row.m3}}</el-col>
                      <el-col :span="20">
                        <el-progress :text-inside="true" :stroke-width="15" :percentage="parseFloat(scope1.row.p3)" :show-text="false" status="warning"></el-progress>
                      </el-col>
                    </el-row>
                  </template>

              </el-table-column>
            </el-table>
            <el-pagination
                background
                :hide-on-single-page = "true"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5,10, 20, 30, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next"
                :total="(computedProject(scope.row.projectid).stores || []).length">
            </el-pagination>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer style="margin:0px;padding:0px;height:30px;" v-if="filterProjectList.length>3">
      <el-pagination
            background
            
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :current-page="currentPage1"
            :page-sizes="[3,5,10,20, 30, 50, 100]"
            :page-size="pageSize1"
            layout="total, sizes, prev, pager, next"
            :total="filterProjectList.length">
        </el-pagination>
    </el-footer>
  </el-container>
</template>

<script>
export default {
    data() {
      return {
        projectList: [],
        loading:true,
        emptytext:"",
        search:'',
        sdcprojects:[],
         // 当前页
        currentPage: 1,
        // 每页多少条
        pageSize: 5,

        currentPage1: 1,
        pageSize1: 3,
      }
    },
    computed:{
      filterProjectList(){
        var search = this.search;
        var list = this.projectList;
        return list.filter(function (item) {
            return item.name.toLowerCase().indexOf(search.toLowerCase()) != -1
        });
      },
      computedProject(){
        return function(projectid) {
          var sdcproject =[];
          this.sdcprojects.forEach(project => {
            if(project.rootid == projectid){
              sdcproject = project;
            }
          });
          return sdcproject;
        }
      },
    },
    mounted() {
      this.loadList();
      this.loadSDCMenu();
    },
    methods:{
      loadList() {
            this.loading = true;
            this.emptytext=" ";
            this.$http.get('project/list',{params:{mode:0}}).then((res) => {
              if(!res) return;
              this.projectList = res.data.list;
              this.loading = false;
              this.emptytext = "";
              });                                                  
        },
      reloadList(){
        this.loadList();
        this.loadSDCMenu();
      },

      createProject(){
        this.$router.push({ path: '/project/new', query:{}})
      },

      editProject(projectID) {
        this.$router.push({ path: '/project/edit', query:{id: projectID}})
      },

      delProject(projectID) {
        this.$confirm("确定要删除研究吗？", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.$http.post('project/delete', {'id':projectID}).then((res) => { 
                this.loadList();
                }); 
            });
      },
      loadSDCMenu(){
        this.$http.get('project/getUserProjects',{}).then((res) => {
          if(!res) return;
          this.sdcprojects = res.data.projects || [];
        }); 
      },
      openSDC(projectID,url){
        this.$http.get('project/open',{params:{id:projectID+'',url:url}}).then((res) => {
                if(!res) return;
                if(res.data.code == 0)
                {
                    window.open(res.data.token);
                } 
                else{
                  this.$alert(res.data.description);
                }
              });
      },


      showfilter(){
        //this.$refs.searchinput.focus();
      },
      handleSelect(index, indexPath) {
        var projectid = indexPath[0].substring(indexPath[0].indexOf("$")+1,indexPath[0].length);
        //console.log(projectid, index, indexPath);
        this.openSDC(projectid,index);
      },

      // 每页多少条
      handleSizeChange(val) {
          this.pageSize = val;
      },
      // 当前页
      handleCurrentChange(val) {
          this.currentPage = val;
      },

      // 每页多少条
      handleSizeChange1(val) {
          this.pageSize1 = val;
      },
      // 当前页
      handleCurrentChange1(val) {
          this.currentPage1 = val;
      },

      SelectMoreMenu(index){
        if(index ==2)
        {
          this.delProject()
        }
      },

      flagStar(projectid,starflag){
        this.$http.post('project/flagstar', {'projectid':projectid,'starflag':starflag}).then((res) => { 
          this.loadList();
        }); 
      },

    }
  };
</script>

<style lang="less" scoped>
  /deep/ .el-table tbody tr:hover>td { background-color: #ffffff!important;}
</style>